$(function() {
    $('.js-view-data-set').on('click', function(e) {
        const $link = $(this);
        e.preventDefault();

        if ($link.closest('.js-change-set-wrapper').find('.js-change-set-view').length > 0) {
            $link.closest('.js-change-set-wrapper').find('.js-change-set-view').remove()
        } else {
            let url = $link.attr('href');

            $.ajax({
                url: url,
                success: function(response) {
                    $link.closest('.js-change-set-wrapper').append(response);
                }
            })
        }
    })

    $('.js-decline-changeset').on('click', function(e) {
        e.preventDefault();

        const id = $(this).data('id');

        const $declineChangeSetModal = $('#decline-changeset-modal')

        if ($declineChangeSetModal.length > 0) {
            $declineChangeSetModal.remove();
        }

        $.ajax({
            url: '/taskChangeset/decline-modal?id=' + id,
            success: function(response) {
                $('body').append(response)
                $('#decline-changeset-modal').modal('show')
            }
        })
    });
})
